import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { format } from 'date-fns';
import produce from 'immer';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as ModalidadeActions } from '../../../store/ducks/modalidade';
import { Creators as RequisicaoActions } from '../../../store/ducks/requisicao';

import TipoPesquisaEnum from '../../../enums/TipoPesquisaBeneficiarioEnum';

import ModalConsultaStructureSegundaVia from '../../molecules/ModalConsultaStructureSegundaVia';
import FormPesquisaBeneficiarioSegundaVia from '../FormPesquisaBeneficiarioSegundaVia';
import TablePesquisaBeneficiarioSegundaVia from '../TablePesquisaBeneficiarioSegundaVia';

function ModalPesquisaBeneficiarioSegundaVia({ isOpen, onCloseModal }) {
  const dispatch = useDispatch();

  const { usuario } = useSelector((state) => state.auth);

  const paginationInitialParams = {
    pageNumber: 1,
    pageSize: 10,
  };

  const paramsRequestDefault = {
    page: 0,
    count_per_page: 10,
    type_query: null,
    contractor_code: usuario.codigoContratante,
    modality_code: null,
    term_number: null,
    unimed_code: null,
    wallet_number: null,
    beneficiary_name: null,
    beneficiary_type: null,
    birth_date: null,
  };
  const formInitialParams = useMemo(
    () => ({
      tipoConsulta: TipoPesquisaEnum.returnPropName.ContratanteModalidadeTermo,
      titular: 'Titular',
      modalidade: '',
      termo: '',
      cartao: '',
      codDaUnimed: '',
      nomeBenefTpBeneficiario: '',
      nomeBeneficiarioI: '',
      dataNascimento: '',
    }),
    []
  );

  const [formParams, setFormParams] = useState(formInitialParams);
  const [paramsRequest, setParamsRequest] = useState(paramsRequestDefault);
  const [paginationParams, setPaginationParams] = useState(
    paginationInitialParams
  );

  const handlePesquisar = useCallback(() => {
    if (!isOpen || formParams === null) {
      return;
    }
    const typeBeneficiary = {
      Titular: 1,
      Dependente: 2,
    };
    const tipoConsulta = TipoPesquisaEnum.returnPropId[formParams.tipoConsulta];
    if (tipoConsulta) {
      const newParamsRequest = produce(paramsRequest, (draft) => {
        draft.type_query = tipoConsulta;
        draft.page = 0;
        draft.count_per_page = 10;

        switch (tipoConsulta) {
          case 1:
            draft.term_number = formParams.termo;
            draft.modality_code = formParams.modalidade;
            break;
          case 2:
            draft.unimed_code = formParams.codDaUnimed;
            draft.wallet_number = formParams.cartao;
            break;
          case 3:
            draft.beneficiary_name = formParams.nomeBenefTpBeneficiario;
            draft.beneficiary_type = typeBeneficiary[formParams.titular];
            break;
          case 4:
            draft.beneficiary_name = formParams.nomeBeneficiarioI;
            draft.birth_date = format(
              formParams.dataNascimento,
              'MM-dd-yyyy 00:00:00'
            );
            break;
          default:
            break;
        }
      });

      setParamsRequest(newParamsRequest);
      dispatch(
        RequisicaoActions.postBeneficiarioSegundaViaRequest(newParamsRequest)
      );
    }
  }, [dispatch, formParams, isOpen, TipoPesquisaEnum, paramsRequest]);

  const handleChangePage = (paramsPag) => {
    const newPaginationParams = produce(paginationParams, (draft) => {
      draft.pageNumber = paramsPag.pageNumber <= 0 ? 1 : paramsPag.pageNumber;
      draft.pageSize = paramsPag.pageSize;
    });
    setPaginationParams(newPaginationParams);

    const newFilterParams = produce(paramsRequest, (draft) => {
      draft.page = paramsPag.pageNumber <= 0 ? 0 : paramsPag.pageNumber - 1;
      draft.count_per_page = paramsPag.pageSize;
    });
    const params = {
      ...paramsRequest,
      ...newFilterParams,
    };

    setParamsRequest(params);
    dispatch(RequisicaoActions.postBeneficiarioSegundaViaRequest(params));
  };

  useEffect(() => {
    dispatch(
      ModalidadeActions.getModalidadesRequest({
        codigoContratante: usuario.codigoContratante,
      })
    );
  }, [dispatch, usuario?.codigoContratante]);

  const desabilitarBtnPesquisar = useMemo(() => {
    const validacaoValues = {
      ContratanteModalidadeTermo:
        !!formParams?.modalidade && !!formParams?.termo,
      ContratanteCodigoUnimedCartao:
        !!formParams?.cartao && !!formParams?.codDaUnimed,
      ContratanteNomeTipoBeneficiario:
        !!formParams?.nomeBenefTpBeneficiario && !!formParams?.titular,
      ContratanteNomeDataNascimento:
        !!formParams?.nomeBeneficiarioI && !!formParams?.dataNascimento,
    };

    return !validacaoValues[formParams.tipoConsulta];
  }, [formParams]);

  return (
    <ModalConsultaStructureSegundaVia
      isOpen={isOpen}
      titleModal={<>Consultar Beneficiário</>}
      onCloseModal={onCloseModal}
      BodyModal={
        <TablePesquisaBeneficiarioSegundaVia
          paginationParams={paginationParams}
          handleChangePage={handleChangePage}
          setPaginationParams={setPaginationParams}
          paramsRequest={paramsRequest}
        />
      }
      HeaderModal={
        <FormPesquisaBeneficiarioSegundaVia
          formParams={formParams}
          setFormParams={setFormParams}
          handlePesquisar={handlePesquisar}
          desabilitarBtnPesquisar={desabilitarBtnPesquisar}
          resetarPagination={() => setPaginationParams(paginationInitialParams)}
        />
      }
    />
  );
}

export default ModalPesquisaBeneficiarioSegundaVia;
